<!--  -->
<template>
  <div class="historypage">
    <div align="center">
      <div id="DomPdf" style="width:1000px; border:1px solid #000000; padding: 45px 57px; box-sizing: border-box;">
        <!-- 标题行 -->
        <el-row class="title">
          <el-col :span="6">
            <div class="blank"></div>
          </el-col>
          <el-col :span="12">
            <span style="text-align: center; display:inline-block; font-size: 24px;">动态血氧检测报告</span>
          </el-col>
          <el-col :span="6">
            <img crossorigin="anonymous" style="width:110px" src="../../../../../public/img/logo_xingou.png" />
          </el-col>
        </el-row>

        <!-- 双横线 -->
        <hr style="height:2px;border:none;border-top:7px double gray;margin-top: 2px;" />

        <!-- 基本信息 -->
        <el-row class="info" style="margin-bottom: 10px;">
          <el-col :span="5">
            <span style="text-align: center; display:inline-block; font-size: 16px;">姓名：{{ realName }}</span>
          </el-col>
          <el-col :span="5">
            <span style="text-align: center; display:inline-block; font-size: 16px;">性别：{{ gender === 1 ? '男' : '女' }}</span>
          </el-col>
          <el-col :span="5">
            <span style="text-align: center; display:inline-block; font-size: 16px;">年龄：{{ age }}</span>
          </el-col>
          <el-col :span="9">
            <span style="text-align: center; display:inline-block; font-size: 16px;">时间：{{ time }}</span>
          </el-col>
        </el-row>

        <!-- 摘要统计卡片 -->
        <el-row :gutter="10" style="margin-bottom: 16px;" v-if="record">
          <el-col :span="8">
            <div class="stat-card spo2-card">
              <div class="stat-title">血氧饱和度 (SpO₂)</div>
              <div class="stat-main">{{ record.latestSpo2 }}<span class="stat-unit">%</span></div>
              <div class="stat-sub">
                平均 {{ record.avgSpo2 }}% &nbsp;|&nbsp;
                最低 <span :class="record.minSpo2 < 90 ? 'warn-text' : ''">{{ record.minSpo2 }}%</span> &nbsp;|&nbsp;
                最高 {{ record.maxSpo2 }}%
              </div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="stat-card pr-card">
              <div class="stat-title">脉率 (PR)</div>
              <div class="stat-main">{{ record.latestPr }}<span class="stat-unit">次/分</span></div>
              <div class="stat-sub">平均 {{ record.avgPr }} 次/分</div>
            </div>
          </el-col>
          <el-col :span="8">
            <div class="stat-card pi-card">
              <div class="stat-title">灌注指数 (PI)</div>
              <div class="stat-main">{{ record.latestPi }}<span class="stat-unit">%</span></div>
              <div class="stat-sub">平均 {{ record.avgPi }}%</div>
            </div>
          </el-col>
        </el-row>

        <!-- SPO2 图表 -->
        <div v-loading="loadingChart" element-loading-text="数据加载中">
          <div style="text-align: left; font-size: 15px; font-weight: bold; margin-bottom: 4px; color: #4da1eb;">
            血氧饱和度 (SpO₂) 趋势
          </div>
          <div id="spo2Chart" style="width: 100%; height: 240px;"></div>

          <!-- PR & PI 图表 -->
          <div style="text-align: left; font-size: 15px; font-weight: bold; margin: 12px 0 4px; color: #67C23A;">
            脉率 (PR) 与灌注指数 (PI) 趋势
          </div>
          <div id="prPiChart" style="width: 100%; height: 240px;"></div>
        </div>

        <!-- 时长信息 -->
        <div v-if="record" style="text-align: left; margin-top: 12px; font-size: 14px; color: #666;">
          监测时长：{{ totalTime }} &nbsp;&nbsp; 采样点数：{{ record.sampleCount }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      time: '',
      totalTime: '',
      realName: '',
      gender: '',
      age: '',
      uid: '',
      id: '',
      record: null,
      samples: [],
      loadingChart: true,
      spo2Chart: null,
      prPiChart: null,
    };
  },
  methods: {
    formatDuration(seconds) {
      let d = Math.floor(seconds / 86400);
      let h = Math.floor((seconds % 86400) / 3600);
      let m = Math.floor((seconds % 3600) / 60);
      let s = seconds % 60;
      if (d > 0) return d + '天' + h + '小时' + m + '分';
      if (h > 0) return h + '小时' + m + '分';
      if (m > 0) return m + '分' + s + '秒';
      return s + '秒';
    },
    getDetail() {
      this.loadingChart = true;
      this.$http({
        url: this.$http.adornUrl('/personal/personaldynamicbloodoxygen/app/detail'),
        method: 'get',
        params: this.$http.adornParams({ id: this.id }),
      }).then(({ data }) => {
        this.loadingChart = false;
        if (data && data.code === 0) {
          this.record = data.data.record;
          this.samples = data.data.samples || [];
          if (this.record && this.record.duration) {
            this.totalTime = this.formatDuration(this.record.duration);
          }
          this.$nextTick(() => {
            this.drawSpo2Chart();
            this.drawPrPiChart();
          });
        } else {
          this.$message.error(data.msg);
        }
      }).catch(() => {
        this.loadingChart = false;
        this.$message.error('数据加载失败');
      });
    },
    drawSpo2Chart() {
      if (!this.samples.length) return;
      const timeList = this.samples.map(s => s.time);
      const spo2List = this.samples.map(s => s.spo2);

      const dom = document.getElementById('spo2Chart');
      if (!dom) return;
      if (this.spo2Chart) this.spo2Chart.dispose();
      this.spo2Chart = this.$echarts.init(dom);

      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            const p = params[0];
            return `时间：${p.axisValue}<br/>血氧：${p.value}%`;
          },
        },
        toolbox: {
          feature: {
            dataZoom: { yAxisIndex: 'none' },
            restore: {},
            saveAsImage: {},
          },
          right: '2%',
        },
        grid: { left: 55, right: 20, top: 20, bottom: 50 },
        xAxis: {
          type: 'category',
          data: timeList,
          axisLabel: {
            rotate: 30,
            fontSize: 11,
            formatter: val => val.substring(11),
          },
        },
        yAxis: {
          type: 'value',
          name: 'SpO₂(%)',
          min: val => Math.max(70, Math.floor(val.min) - 2),
          max: 100,
          axisLabel: { formatter: '{value}%' },
          splitLine: { show: true },
        },
        dataZoom: [
          { type: 'inside', start: 0, end: 100 },
          { type: 'slider', start: 0, end: 100, height: 20, bottom: 5 },
        ],
        // 90% 参考线
        series: [
          {
            name: 'SpO₂',
            type: 'line',
            data: spo2List,
            symbol: 'none',
            lineStyle: { color: '#4da1eb', width: 2 },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [
                  { offset: 0, color: 'rgba(77,161,235,0.3)' },
                  { offset: 1, color: 'rgba(77,161,235,0.02)' },
                ],
              },
            },
            markLine: {
              silent: true,
              lineStyle: { color: '#F56C6C', type: 'dashed' },
              data: [{ yAxis: 90, name: '90% 警戒线' }],
              label: { formatter: '{b}', position: 'end' },
            },
          },
        ],
      };

      this.spo2Chart.setOption(option);
      window.addEventListener('resize', () => { if (this.spo2Chart) this.spo2Chart.resize(); });
    },
    drawPrPiChart() {
      if (!this.samples.length) return;
      const timeList = this.samples.map(s => s.time);
      const prList = this.samples.map(s => s.pr);
      const piList = this.samples.map(s => s.pi);

      const dom = document.getElementById('prPiChart');
      if (!dom) return;
      if (this.prPiChart) this.prPiChart.dispose();
      this.prPiChart = this.$echarts.init(dom);

      const option = {
        tooltip: {
          trigger: 'axis',
          formatter: params => {
            let result = `时间：${params[0].axisValue}<br/>`;
            params.forEach(p => {
              const unit = p.seriesName === '脉率(PR)' ? '次/分' : '%';
              result += `${p.marker}${p.seriesName}：${p.value}${unit}<br/>`;
            });
            return result;
          },
        },
        toolbox: {
          feature: {
            dataZoom: { yAxisIndex: 'none' },
            restore: {},
            saveAsImage: {},
          },
          right: '2%',
        },
        legend: { data: ['脉率(PR)', '灌注指数(PI)'], top: 0 },
        grid: { left: 55, right: 55, top: 30, bottom: 50 },
        xAxis: {
          type: 'category',
          data: timeList,
          axisLabel: {
            rotate: 30,
            fontSize: 11,
            formatter: val => val.substring(11),
          },
        },
        yAxis: [
          {
            type: 'value',
            name: 'PR(次/分)',
            nameTextStyle: { color: '#67C23A' },
            axisLine: { lineStyle: { color: '#67C23A' } },
            axisLabel: { color: '#67C23A' },
          },
          {
            type: 'value',
            name: 'PI(%)',
            nameTextStyle: { color: '#E6A23C' },
            axisLine: { lineStyle: { color: '#E6A23C' } },
            axisLabel: { color: '#E6A23C' },
            splitLine: { show: false },
          },
        ],
        dataZoom: [
          { type: 'inside', start: 0, end: 100 },
          { type: 'slider', start: 0, end: 100, height: 20, bottom: 5 },
        ],
        series: [
          {
            name: '脉率(PR)',
            type: 'line',
            yAxisIndex: 0,
            data: prList,
            symbol: 'none',
            lineStyle: { color: '#67C23A', width: 2 },
            itemStyle: { color: '#67C23A' },
          },
          {
            name: '灌注指数(PI)',
            type: 'line',
            yAxisIndex: 1,
            data: piList,
            symbol: 'none',
            lineStyle: { color: '#E6A23C', width: 2 },
            itemStyle: { color: '#E6A23C' },
          },
        ],
      };

      this.prPiChart.setOption(option);
      window.addEventListener('resize', () => { if (this.prPiChart) this.prPiChart.resize(); });
    },
    getinfo() {
      this.$http({
        url: this.$http.adornUrl('/personal/info/getBasicInfo'),
        method: 'get',
        params: this.$http.adornParams({ uid: this.uid }),
      }).then(({ data }) => {
        if (data && data.code === 0) {
          this.realName = data.realName;
          this.gender = data.gender;
          this.age = data.age;
        } else {
          this.$message.error(data.msg);
        }
      });
    },
  },
  created() {
    this.id = this.$route.query.id;
    this.uid = this.$route.query.uid;
    this.time = this.$route.query.RecordCreatetime;
    this.totalTime = this.$route.query.totalTime || '';
  },
  mounted() {
    this.getinfo();
    this.getDetail();
  },
  beforeDestroy() {
    if (this.spo2Chart) this.spo2Chart.dispose();
    if (this.prPiChart) this.prPiChart.dispose();
  },
};
</script>

<style scoped>
.blank {
  border-radius: 4px;
  height: 18px;
}

.stat-card {
  border-radius: 8px;
  padding: 12px 16px;
  text-align: center;
  border: 1px solid #ebeef5;
}

.spo2-card {
  background: linear-gradient(135deg, #e8f4fd, #d0e8f9);
  border-color: #4da1eb;
}

.pr-card {
  background: linear-gradient(135deg, #e8f8e8, #d0f0d0);
  border-color: #67C23A;
}

.pi-card {
  background: linear-gradient(135deg, #fdf6e8, #f9ecd0);
  border-color: #E6A23C;
}

.stat-title {
  font-size: 13px;
  color: #666;
  margin-bottom: 6px;
}

.stat-main {
  font-size: 32px;
  font-weight: bold;
  color: #333;
  line-height: 1.2;
}

.stat-unit {
  font-size: 14px;
  font-weight: normal;
  color: #666;
  margin-left: 4px;
}

.stat-sub {
  font-size: 13px;
  color: #666;
  margin-top: 4px;
}

.warn-text {
  color: #F56C6C;
  font-weight: bold;
}
</style>
